import styles from './feature-idea-suggestion.module.less';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface FeatureIdeaSuggestionProps {}

export function FeatureIdeaSuggestion(props: FeatureIdeaSuggestionProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_idea_suggestion')}</h1>
    </div>
  );
}

export default FeatureIdeaSuggestion;
